import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllMstVatSlice = createSlice({
    name: "getAllMstVat",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllMstVatSlice_actions = getAllMstVatSlice.actions;
export var fetchData = _getAllMstVatSlice_actions.fetchData, fetchDataSuccess = _getAllMstVatSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllMstVatSlice_actions.fetchDataFailure, resetState = _getAllMstVatSlice_actions.resetState;
export default getAllMstVatSlice.reducer;
